<template>
  <div class="field is-grouped is-grouped-centered">
    <div v-for="score in _.reverse(scores)" :key="score.value"
         class="button"
         :class="{ 'is-primary': score.active, 'is-outlined is-primary': !score.active }"
         style="height: 40px; width: 100%; margin: 0 0.3rem;"
         @click="!disabled && selectAnswer(score.value)">
      <div>
        {{ score.value === 1 ? $t('modal.actions.yes') : $t('modal.actions.no') }}
      </div>
    </div>
  </div>
</template>

<script>

const SCORES_DEFAULT = [
  { active: false, value: 0 },
  { active: false, value: 1 },
];

export default {
  name: 'YesNo',
  props: {
    disabled: { type: Boolean, default: false },
    default_value: { type: Number, default: null },
  },

  data() {
    const scores = _.cloneDeep(SCORES_DEFAULT);
    if (!_.isNil(this.default_value)) scores[this.default_value].active = true;
    return { scores };
  },

  watch: {
    default_value() {
      this.scores = _.cloneDeep(SCORES_DEFAULT);
      if (!_.isNil(this.default_value)) this.scores[this.default_value].active = true;
    },
  },

  methods: {
    selectAnswer(answer) {
      this.scores = _.cloneDeep(SCORES_DEFAULT);
      this.scores[answer].active = true;
      this.$emit('scoreSelected', this.scores[answer].value);
    },
  },
};
</script>
